<div class="row g-4 mb-3">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div class="d-flex align-items-center">
                            <i class="card-title-icon fa-solid fa-comments material-icon-fa me-2"
                                aria-hidden="true"></i>
                            <h2 class="dashboard-card-title">Comment History</h2>
                        </div>
                        <p class="dashboard-card-subtitle">Messages with Self-Help staff</p>
                    </div>
                </div>
            </div>

            <div class="card-body">
                @if (isLoadingHistory()) {
                <div class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading messages...</span>
                    </div>
                </div>
                } @else {
                <!-- Message history -->
                <div class="conversation-container mb-4"
                    [class.conversation-container-empty]="conversationHistory().length === 0" role="log"
                    aria-label="Comment History" aria-live="polite" style="max-height: 400px; overflow-y: auto;">
                    @if (conversationHistory().length > 0) {
                    @for (conversationItem of conversationHistory(); track
                    conversationItem.serviceRequestConversationId)
                    {
                    @if (isInternalMessage(conversationItem)) {
                    <!-- Staff message (right side) -->
                    <div class="d-flex justify-content-start mb-3">
                        <div class="message-bubble message-staff" role="article"
                            [attr.aria-label]="'Message from Self Help Team on ' + formatMessageDate(conversationItem.createdDate)">
                            <div class="message-header">
                                <strong>Self-Help Team</strong>
                                <small class="text-muted ms-2">{{ formatMessageDate(conversationItem.createdDate)
                                    }}</small>
                            </div>
                            <div class="message-body">
                                {{ conversationItem.messageBody }}
                            </div>
                            @if (getConversationDocuments(conversationItem.serviceRequestConversationId).length > 0) {
                            <div class="conversation-attachments mt-2">
                                @for (document of getConversationDocuments(conversationItem.serviceRequestConversationId);
                                track document.serviceRequestDocumentId) {
                                <a [href]="document.fileUrl" target="_blank" rel="noopener"
                                    class="conversation-attachment-link"
                                    [attr.aria-label]="'View attachment ' + document.originalFileName">
                                    <i class="fa-solid" [class]="getDocumentIcon(document.fileExtension)"
                                        aria-hidden="true"></i>
                                    <span>{{ document.originalFileName }}</span>
                                </a>
                                }
                            </div>
                            }
                        </div>
                    </div>
                    } @else {
                    <!-- User message (left side) -->
                    <div class="d-flex justify-content-end mb-3">
                        <div class="message-bubble message-user" role="article"
                            [attr.aria-label]="conversationItem.isSending ? 'Your message, sending...' : 'Your message on ' + formatMessageDate(conversationItem.createdDate)">
                            <div class="message-header">
                                <strong>You</strong>
                                @if (conversationItem.isSending) {
                                <span class="ms-2">
                                    <span class="spinner-border spinner-border-sm text-muted" role="status"
                                        aria-hidden="true"></span>
                                    <span class="visually-hidden">Sending...</span>
                                </span>
                                } @else {
                                <small class="text-muted ms-2">{{ formatMessageDate(conversationItem.createdDate)
                                    }}</small>
                                }
                            </div>
                            <div class="message-body">
                                {{ conversationItem.messageBody }}
                            </div>
                            @if (getConversationDocuments(conversationItem.serviceRequestConversationId).length > 0) {
                            <div class="conversation-attachments mt-2">
                                @for (document of getConversationDocuments(conversationItem.serviceRequestConversationId);
                                track document.serviceRequestDocumentId) {
                                <a [href]="document.fileUrl" target="_blank" rel="noopener"
                                    class="conversation-attachment-link"
                                    [attr.aria-label]="'View attachment ' + document.originalFileName">
                                    <i class="fa-solid" [class]="getDocumentIcon(document.fileExtension)"
                                        aria-hidden="true"></i>
                                    <span>{{ document.originalFileName }}</span>
                                </a>
                                }
                            </div>
                            }
                        </div>
                    </div>
                    }
                    }
                    } @else {
                    <div class="d-flex align-items-center justify-content-center h-100" role="status">
                        <div class="text-center text-muted">
                            <i class="fa-solid fa-comment-slash fs-1 mb-3 d-block" aria-hidden="true"></i>
                            <p class="mb-0">No comments to display</p>
                        </div>
                    </div>
                    }
                </div>
                <form [formGroup]="messageForm"> 
                    <!-- Message input -->
                    <div class="message-input-container" role="region" aria-label="Add a comment">
                        <input #attachmentInput type="file" class="d-none" aria-hidden="true" tabindex="-1" multiple 
                            (change)="onAttachmentSelected($event)" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" />

                        <div class="d-flex flex-column flex-md-row align-items-stretch gap-3">
                            <div class="flex-grow-1">
                                <label for="commentInput" class="visually-hidden">Comment</label>
                                <textarea id="commentInput" formControlName="message" 
                                    class="form-control comment-input h-100"
                                    placeholder="Type your message..." aria-describedby="commentHint"></textarea>
                                <span id="commentHint" class="visually-hidden">
                                    Type your comment then press Send Message to submit
                                </span>
                            </div>

                            <div class="d-flex flex-column gap-2 flex-shrink-0">
                                <button type="button" class="btn btn-primary py-3"
                                    (click)="sendMessage(attachmentInput)"
                                    [disabled]="!canSend()" [attr.aria-disabled]="!canSend()"
                                    aria-label="Send message">
                                    <i class="fa-solid fa-paper-plane me-2" aria-hidden="true"></i>
                                    Send Message
                                </button>

                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="openAttachmentPicker(attachmentInput)" aria-label="Add attachment">
                                    <i class="fa-solid fa-paperclip me-2" aria-hidden="true"></i>
                                    Attach File
                                </button>
                            </div>
                        </div>

 @if (selectedAttachments().length > 0) {
                        <ul class="list-group mt-2" aria-label="Selected attachments">
                            @for (file of selectedAttachments(); track file.name) {
                            <li class="list-group-item py-2">
                                <div class="d-flex align-items-center gap-2">
                                    <!-- Icon (hidden on mobile) -->
                                    <div class="file-icon d-none d-md-flex" aria-hidden="true">
                                        <i class="fas fa-file text-muted fs-4"></i>
                                    </div>
                                    <!-- Filename - takes all remaining left space -->
                                    <span class="fw-semibold text-truncate flex-grow-1 min-w-0" [title]="file.name">
                                        {{ file.name }}
                                    </span>
                                    <!-- Right side: type, size, remove - all pinned right -->
                                    <div class="d-flex align-items-center gap-2 flex-shrink-0">
                                        <span class="badge bg-primary">{{ getFileExtension(file) }}</span>
                                        <span class="small text-muted text-nowrap">{{ formatFileSize(file.size)
                                            }}</span>
                                        <button type="button" class="btn btn-sm btn-link p-1"
                                            (click)="removeAttachment(file)"                                            [attr.aria-label]="'Remove ' + file.name">
                                            <i class="fas fa-times fs-4 text-primary"></i>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            }
                        </ul>
                        }

                        @if (attachmentError(); as error) {
                        <div class="alert alert-danger mt-2 py-2 small mb-0" role="alert">
                            <i class="fa-solid fa-triangle-exclamation me-2" aria-hidden="true"></i>
                            {{ error }}
                        </div>
                        }

                        <p class="small text-muted mt-2 mb-0 float-end">
                            Accepted: PDF, JPG, PNG, DOCX &nbsp;|&nbsp; Max 25 MB per file
                        </p>
                    </div>
                </form>

                }
            </div>
        </div>
    </div>
</div>
